<template>
  <div id="locations--map-wrapper">
    <div class="locations--map-pane">
      <div id="locations--map" ref="map"></div>
      <div
        class="locations--search-area"
        v-if="showSearchAreaButton && !loading && !locating && !failed"
      >
        <button class="button primary" @click.prevent="searchInVisibleArea">
          SEARCH THIS AREA
        </button>
      </div>
    </div>
    <div style="height: 600px;overflow: hidden;" class="locations--map-search">
      <form @submit.prevent="searchLocations()" class="locations--search">
        <div class="locations--search-input">
          <input type="text" v-model="search" value="" :placeholder="strings.SEARCH" />
          <button type="submit" value="Search" class="button-search">
            <i class="fas fa-search"></i>
          </button>
        </div>
        <div class="text-center push-up-single" v-if="ignoreUserLocation">
          <a id="searchLiveLocation" class="button push-down-none" @click.prevent="getNearestLocations()"><i class="fas fa-location-arrow"></i> Use My Location</a>
        </div>
      </form>
      <div class="loader loading" v-if="loading"></div>
      <div class="loading" v-if="locating">
        <p>
          <strong>{{ strings.GETTING }}... </strong>
        </p>
        {{ strings.ALLOW }}.
      </div>
      <div class="loading" v-if="loading && !locating">
        <div>
          <i class="far fa-location-arrow"></i> {{ strings.FINDING }}...
        </div>
      </div>
      <div class="loading" v-if="failed">
        <p>
          <strong>{{ strings.GETTING_FAILED }}.</strong>
        </p>
        {{ strings.ENABLE_GEO }}. <br /><br />
        <a @click="getNearestLocations()" class="button">{{
          strings.TRY_AGAIN
          }}</a>
      </div>
      <div class="loading" v-if="
        !loading &&
        !locating &&
        !failed &&
        markers.length < 1 &&
        locations.length < 1
      ">
        {{ strings.FINDING_FAILED }}.
      </div>
      <div class="loading" v-if="showingClosestFallback && !loading && !failed">
        No locations were found in this area. Showing the closest locations instead.
      </div>
      <div class="locations--map-list" v-show="locations && !loading && !failed">
        <div class="location customLocationC" :data-highlighted="location.ID == l.location.ID" v-for="(l, key) in locations" @click="highlightLocation(l.location)" :key="l.location.ID || key" :data-id="l.location.ID">
          <div class="details">
            <h3 class="name" @click.stop>
              <a :href="l.location.url"><span v-html="l.location.post_title"></span></a>
            </h3>

            <div class="address">
              <!-- This Field displays if location is closed or open. We want to display shop that are open.-->
              {{ l.location.customFields.location_closed }}
              {{ l.location.customFields.address?.[0] }}
              {{ l.location.customFields.address_2?.[0] }}
            </div>
            <div>
              {{ l.location.customFields.city?.[0] }},
              {{ l.location.customFields.state?.[0] }}
              {{ l.location.customFields.zip_code?.[0] }}
            </div>
            <div v-if="
              typeof l.location.customFields.tracking_number?.[0] !==
              'undefined'
            ">
              <a class="phone tracking" @click.stop :href="`tel:${l.location.customFields.tracking_number[0]}`">{{ l.location.customFields.tracking_number[0] }}</a>
            </div>
            <div v-else-if="
              typeof l.location.customFields.phone_number_toll_free?.[0] !==
              'undefined'
            ">
              <a class="phone toll-free" @click.stop :href="`tel:${l.location.customFields.phone_number_toll_free[0]}`">{{ l.location.customFields.phone_number_toll_free[0] }}</a>
            </div>
            <div v-else-if="l.location.customFields.phone_number?.[0]">
              <a class="phone" @click.stop :href="`tel:${l.location.customFields.phone_number[0]}`">{{ l.location.customFields.phone_number[0] }}</a>
            </div>
            <div v-if="l.location.customFields.st_store_type?.[0] === 'Enrollment' || l.location.customFields.st_store_type === 'Enrollment'">
              <span><i class="far fa-map fa-fw"></i> Enrollment Location</span>
            </div>
            <div v-if="l.location.customFields.location_finder_promo?.[0]">
              <span class="color-accent">{{
                l.location.customFields.location_finder_promo[0]
                }}</span>
            </div>
          </div>
          <div class="actions text-center">
            <!-- <a href="#schedule" class="button primary">{{ strings.SCHEDULE }}</a> -->
            <a @click.prevent.stop="setScheduleLocation(l.location)" class="button primary">{{ strings.SCHEDULE }}</a>
            <a :href="directionURL(l)" @click.stop target="_blank" class="directions"><span v-if="l.distance" class="directions" :title="'Get Directions'">{{ l.distance | distance }} &mdash;</span>
              {{ strings.MAP_IT }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SmoothScroll from "smooth-scroll";
function QueryParam(param) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == param) {
      return unescape(pair[1]);
    }
  }
  return false;
}
export default {
  props: ["defaultLocation"],
  data: function () {
    return {
      strings: window.draegerLocationFinderStrings,
      ignoreUserLocation: true,
      loading: false,
      locating: false,
      location: { id: false },
      highlight: false,
      failed: false,
      mapElement: false,
      listElement: false,
      search: "",
      position: false,
      positionMarker: false,
      locations: [],
      allLocations: [],
      markers: [],
      showSearchAreaButton: false,
      suppressSearchAreaButton: false,
      hasUserMapInteraction: false,
      showingClosestFallback: false,
      options: {
        // radius: 100,
        zoom: 5,
        scrollWheel: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: true,
        gestureHandling: "greedy",
        center: { lat: 39.8283, lng: -98.5795 },
        pinPath: "/wp-content/themes/bowtie/assets/images/",
        pinSize: [42, 42],
      },
      cancelToken: null,
      currentInfoWindowC: null,
    };
  },
  methods: {
    queueSuppressSearchAreaButton: function () {
      this.suppressSearchAreaButton = true;
      setTimeout(() => {
        this.suppressSearchAreaButton = false;
      }, 500);
    },
    maybeShowSearchAreaButton: function () {
      if (
        !this.hasUserMapInteraction ||
        this.suppressSearchAreaButton ||
        this.loading ||
        this.failed
      ) return;
      this.showSearchAreaButton = true;
    },
    parseLocationPosition: function (loc) {
      if (!loc || !loc.location || !loc.location.customFields) return false;
      const coords = loc.location.customFields;
      const latRaw = Array.isArray(coords.latitude) ? coords.latitude[0] : coords.latitude;
      const lngRaw = Array.isArray(coords.longitude) ? coords.longitude[0] : coords.longitude;
      const lat = Number(latRaw);
      const lng = Number(lngRaw);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return false;
      return { lat, lng };
    },
    renderLocations: function (locations = []) {
      this.clearLocations();
      locations.forEach((loc) => {
        if (loc.location.customFields.location_closed == undefined) {
          this.locations.push(loc);
          if (this.map) {
            let marker = this.addMarker(loc.location, loc.location.post_title);
            marker.addListener("click", () => {
              this.highlightLocation(loc.location);
            });
          }
        }
      });
      this.$nextTick(() => {
        this.getVisibleMarkers();
      });
    },
    fitMapToMarkers: function () {
      if (!this.map || !this.markers || this.markers.length < 1) return;
      if (this.markers.length === 1) {
        this.map.setCenter(this.markers[0].getPosition());
        this.map.setZoom(10);
        return;
      }

      const bounds = new google.maps.LatLngBounds();
      this.markers.forEach((marker) => bounds.extend(marker.getPosition()));
      this.map.fitBounds(bounds);
    },
    cacheAllLocations: function () {
      if (this.allLocations.length) {
        return Promise.resolve(this.allLocations);
      }

      return axios
        .get("/wp-json/locations/all")
        .then((response) => {
          this.allLocations = response.data || [];
          return this.allLocations;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    fetchLocationsByBounds: function () {
      if (!this.map) return Promise.resolve([]);

      const bounds = this.map.getBounds();
      if (!bounds) return Promise.resolve([]);

      return this.cacheAllLocations()
        .then((locations) => {
          const visibleLocations = (locations || []).filter((loc) => {
            const position = this.parseLocationPosition(loc);
            if (!position) return false;
            return bounds.contains(new google.maps.LatLng(position.lat, position.lng));
          });
          this.renderLocations(visibleLocations);
          return visibleLocations;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    searchInVisibleArea: function () {
      this.showingClosestFallback = false;
      this.loading = true;
      this.fetchLocationsByBounds()
        .then((visibleLocations) => {
          if (visibleLocations && visibleLocations.length > 0) {
            this.showSearchAreaButton = false;
            this.loading = false;
            return;
          }

          const center = this.map ? this.map.getCenter() : null;
          if (!center) {
            this.showSearchAreaButton = false;
            this.loading = false;
            return;
          }

          return this.getNearest({
            latitude: center.lat(),
            longitude: center.lng(),
          }).then((nearestLocations) => {
            if (nearestLocations && nearestLocations.length > 0) {
              this.renderLocations(nearestLocations);
              this.showingClosestFallback = true;
              this.$nextTick(() => {
                this.fitMapToMarkers();
              });
            }
            this.showSearchAreaButton = false;
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getNearest: function (position) {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }

      this.cancelToken = new axios.CancelToken.source();
      // console.log('getting nearest')
      return axios
        .get("/wp-json/locations/nearest", {
          params: {
            latitude: position.latitude,
            longitude: position.longitude,
          },
          cancelToken: this.cancelToken.token,
        })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNearestLocations: function () {
      this.ignoreUserLocation = false;
      this.location = false;
      this.locations = [];
      this.showingClosestFallback = false;
      this.showSearchAreaButton = false;
      this.loading = true;
      this.failed = false;
      this.search = "";
      this.locating = true;
      this.requestUserLocation()
        .then((coordinates) => {
          this.setPosition(coordinates);
          this.locating = false;
          this.loading = true;
          return this.getNearest(coordinates);
        })
        .then((locations) => {
          this.clearLocations();
          this.loading = true;
          locations.forEach((loc) => {
            if (loc.location.customFields.location_closed == undefined) {

              this.locations.push(loc);
              let marker = this.addMarker(
                loc.location,
                loc.location.post_title
              );
              marker.addListener("click", (e) => {
                this.highlightLocation(loc.location);
              });
            }
          });
          setTimeout(() => {
            this.queueSuppressSearchAreaButton();
            this.map.setZoom(10);

          }, 2);
          console.log(document.getElementById("searchLiveLocation"));
          this.loading = false;
          return locations;
        })
        .then((locations) => {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            {
              location: this.position,
            },
            (results, status) => {
              if (status == "OK") {
                let zip = results[0].address_components.find(
                  (c) => c.types.indexOf("postal_code") > -1
                );
                let city = results[0].address_components.find(
                  (c) => c.types.indexOf("locality") > -1
                );
                // Analytics to report the best places for
                // new locations
                if (locations.length == 0) {
                  // Send NoLocationsFound event with zip code
                  // if locations nearby == 0
                  window.dataLayer.push({
                    event: "eventTracking",
                    category: "LocationFinder",
                    action: "NoLocationsFound",
                    label: zip ? "ZipCode" : "City",
                    value: zip ? zip.short_name : city.short_name,
                  });
                } else {
                  // Send LocationsFound event with zip code
                  // if locations nearby > 0
                  window.dataLayer.push({
                    event: "eventTracking",
                    category: "LocationFinder",
                    action: "LocationsFound",
                    label: zip ? "ZipCode" : "City",
                    value: zip ? zip.short_name : city.short_name,
                  });
                }
              }
            }
          );
        })
        .catch(() => {
          this.failed = true;
          this.loading = false;
          this.locating = false;

          if (this.ignoreUserLocation) {
            this.search = this.$el.getAttribute("data-default-search");
            this.searchLocations();
            return;
          }
        });
    },
    requestUserLocation: function () {
      return new Promise((resolve, reject) => {
        if (this.ignoreUserLocation) return reject();
        // Check for cached position in sessionStorage
        if (typeof this.position.latitude !== "undefined") {
          return resolve(this.position);
        } else if (navigator.geolocation) {
          // Otherwise get their current location
          let closeBy = [];
          navigator.geolocation.getCurrentPosition(
            (position) => {
              if (sessionStorage)
                sessionStorage.position = JSON.stringify({
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                });
              return resolve(position.coords);
            },
            () => {
              // Could not get current position
              return reject("Could not get current position");
            }
          );
        } else {
          // Browser doesn't support Geolocation
          return reject("Browser does not support geolocation");
        }
      });
    },
    fetchLocations: function () {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }

      this.cancelToken = new axios.CancelToken.source();
      // console.log('fetching locations')
      return axios
        .get("/wp-json/locations/all", {
          cancelToken: this.cancelToken.token,
        })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showAllLocations: function () {
      this.location = false;
      this.locating = false;
      this.loading = true;
      this.failed = false;
      this.showingClosestFallback = false;
      this.showSearchAreaButton = false;
      this.clearLocations();
      this.fetchLocations()
        .then((locations) => {
          this.allLocations = locations || [];
          locations.forEach((loc) => {
            if (loc.location.customFields.location_closed == undefined) {
              this.locations.push(loc);
              if (this.map) {
                let marker = this.addMarker(
                  loc.location,
                  loc.location.post_title
                );
                marker.addListener("click", (e) => {
                  this.highlightLocation(loc.locations);
                });
              }
            }
          });
          if (this.map) this.map.setCenter(this.options.center);
          if (this.map) this.map.setZoom(this.options.zoom);
          this.loading = false;
        })
        .catch((err) => {
          //this.failed = true;
          //this.loading = false;
          console.log(err);
        });
    },


    searchLocations: function () {
      this.ignoreUserLocation = false;
      this.location = false;
      this.locating = false;
      this.showingClosestFallback = false;
      this.showSearchAreaButton = false;
      if (this.search == "") return;
      this.loading = true;
      this.failed = false;
      this.clearLocations();
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: this.search,
          componentRestrictions: {
            country: "US",
          },
        },
        (results, status) => {
          if (status == "OK") {
            let location = {
              latitude: results[0].geometry.location.lat(),
              longitude: results[0].geometry.location.lng(),
            };
            let zip = results[0].address_components.find(
              (c) => c.types.indexOf("postal_code") > -1
            );
            let city = results[0].address_components.find(
              (c) => c.types.indexOf("locality") > -1
            );

            this.setPosition(location);
            this.getNearest(location).then((locations) => {
              locations.forEach((loc) => {
                if (loc.location.customFields.location_closed == undefined) {

                  this.locations.push(loc);
                  if (this.map) {

                    let marker = this.addMarker(
                      loc.location,
                      loc.location.post_title
                    );
                    marker.addListener("click", (e) => {
                      this.highlightLocation(loc.location);
                    });
                  }
                }
              });

              this.loading = false;

              setTimeout(() => {
                this.map.setZoom(10);
              }, 3);

              // Analytics to report the best places for
              // new locations
              if (locations.length == 0) {
                // Send NoLocationsFound event with zip code
                // if locations nearby == 0
                window.dataLayer.push({
                  event: "eventTracking",
                  category: "NoLocationsFound",
                  action: zip ? "Zip Code" : "City",
                  label: zip ? zip.short_name : city.short_name,
                });
              } else {
                // Send LocationsFound event with zip code
                // if locations nearby > 0
                window.dataLayer.push({
                  event: "eventTracking",
                  category: "LocationsFound",
                  action: zip ? "Zip Code" : "City",
                  label: zip ? zip.short_name : city.short_name,
                });
              }
            });
          } else {
            this.failed = true;
            this.loading = false;
          }
        }
      );
    },
    initMap: function () {
      if (this.$refs.map)
        this.map = new google.maps.Map(this.$refs.map, {
          center: this.options.center,
          scrollwheel: this.options.scrollWheel,
          streetViewControl: this.options.streetViewControl,
          mapTypeControl: this.options.mapTypeControl,
          fullscreenControl: this.options.fullscreenControl,
          cameraControl: false,
          zoomControl: this.options.zoomControl,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          gestureHandling: this.options.gestureHandling,
          zoom: this.options.zoom,
          clickableIcons: false,
          disableDefaultUI: false,
        });
      // Close the info window when clicking on the map
      this.map.addListener("click", () => {
        this.hasUserMapInteraction = true;
        console.log("currentInfoWindowC");
        console.log(this.currentInfoWindowC);
        if (this.currentInfoWindowC) {
          this.currentInfoWindowC.close();
          this.currentInfoWindowC = null;
        }
        this.maybeShowSearchAreaButton();
      });


      if (this.search) {
        // console.log('searching locations')
        return this.searchLocations();
      }

      if (QueryParam("schedule")) {
        let form = document.querySelector("#gform_wrapper_26 form");
        if (form) {
          axios
            .get("/wp-json/wp/v2/location/" + QueryParam("schedule"))
            .then((location) => {
              this.setScheduleLocation(location.data);
            });
          new SmoothScroll().animateScroll(form, false, {
            offset: 200,
          });
        }
      }

      // console.log('showing all locations')
      this.showAllLocations();

      // Add a listener for zoom changes 
      this.map.addListener('zoom_changed', () => {
        // console.log('zoom chnage');
        this.getVisibleMarkers();
        this.maybeShowSearchAreaButton();
      });
      // Add a listener for bounds changes (including pan/zoom) 
      this.map.addListener('bounds_changed', () => {
        // console.log("boundsChnage");
        this.getVisibleMarkers();
      });
      this.map.addListener("dragend", () => {
        this.hasUserMapInteraction = true;
        this.maybeShowSearchAreaButton();
      });

    },
    getVisibleMarkers: function () {
      this.loading = false;
      // console.log/('function run succ');
      if (this.map) {
        if (this.showingClosestFallback) {
          document.querySelectorAll('.location').forEach(location => { location.style.display = 'flex'; });
          return;
        }
        const bounds = this.map.getBounds();
        const visibleMarkers = this.markers.filter(marker => bounds.contains(marker.getPosition()));
        document.querySelectorAll('.location').forEach(location => { location.style.display = 'none'; });
        if (visibleMarkers.length > 0) {
          // Hide all location elements 
          visibleMarkers.forEach(visibleMarker => {

            // Show only the location elements with matching data-id 
            let maindiv = document.querySelector(`.location[data-id="${visibleMarker.id}"]`);
            if (maindiv) maindiv.style.display = 'flex';
            // console.log('Visible markers:', maindiv);
          });
        }
        // You can now do something with the visible markers, like displaying their data 
      }
    },

    addMarker: function (location = {}, title = "", favorite = false, isCurrentLocation = false) {


      let coords = location.customFields;

      let icon = {
        url: this.options.pinPath + (isCurrentLocation ? "current-location-marker.svg" : "marker.svg"),
        scaledSize: new google.maps.Size(32, 44),
      };

      let position = {
        lat: isCurrentLocation ? coords.latitude : Number(coords.latitude?.[0]),
        lng: isCurrentLocation ? coords.longitude : Number(coords.longitude?.[0]),
      };

      let marker = new google.maps.Marker({
        position: position,
        title,
        icon,
        id: location.ID
      });

      let address = `${coords.address?.[0]} ${coords.address_2?.[0]}, ${coords.city?.[0]}, ${coords.state?.[0]} ${coords.zip_code?.[0]}`;
      let googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

      let infoWindowContent = `
    <div>
      <div class="infoWindow-shopName">
        <a href=${location.url}>
          <h3>${location.post_title}</h3>
        </a>
      </div>
      <p>${address}</p>
      <p><a href="tel:${coords.phone_number?.[0]}">${coords.phone_number?.[0]}</a></p>
      <p class="infowWindow-map"><a href="${googleMapsUrl}" target="_blank">Map It</a></p>
      <div class="actions">
        <a href="#schedule" id="scheduleBtn" class="button primary">Schedule Appointment</a>
      </div>
    </div>
  `;

      let infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent,
      });

      marker.addListener("click", () => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
        infoWindow.open(this.map, marker);
        this.currentInfoWindow = infoWindow;
        this.currentInfoWindowC = infoWindow;
        this.scrollToLocationsec(location.ID);
        this.highlightLocation(coords);

        google.maps.event.addListener(infoWindow, 'domready', () => {
          document.getElementById("scheduleBtn").addEventListener('click', () => {
            this.setScheduleLocation(location);
          });
        });
      });

      this.markers.push(marker);
      marker.setMap(this.map);
      return marker;
    },

    addCurrentLocationMarker: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let currentLocation = {
            customFields: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
          };
          this.addMarker(currentLocation, "Current Location", false, true);
        }, (error) => {
          console.error("Error fetching geolocation: ", error);
        });
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },

    scrollToLocationsec: function (locationId) {
      // Select the parent container
      const container = document.querySelector('.locations--map-list');


      // Find the child element with the specific data-id
      const target = container.querySelector(`.location[data-id="${locationId}"]`);

      if (target) {


        // Remove the highlight class from all locations
        const allLocations = container.querySelectorAll('.location');
        allLocations.forEach(location => location.classList.remove('highlight'));

        // Add the highlight class to the target element
        target.classList.add('highlight');

        // Scroll the container to the child element with smooth behavior
        // Calculate the top position of the target element 
        const topPos = target.offsetTop - container.offsetTop;
        // Use the scrollTo method with behavior: 'smooth' for smooth scrolling 
        container.scrollTo({ top: topPos, behavior: 'smooth' });
      } else {
        console.log(`Location with id ${locationId} not found.`);
      }
    },



    mounted: function () {
      // Initialize the map
      this.initMap();

      // Close the info window when clicking anywhere in the document
      document.addEventListener("click", (event) => {
        if (this.currentInfoWindow) {
          const infoWindowElement = document.querySelector('.gm-style-iw');
          if (infoWindowElement && !infoWindowElement.contains(event.target)) {
            this.currentInfoWindow.close();
            this.currentInfoWindow = null;
          }
        }
      });

      // Add listeners to update locations when map bounds change
      this.map.addListener("bounds_changed", () => {
        // this.fetchLocationsByBounds();
      });

      // Initial fetch of locations based on the default map bounds
      this.fetchLocationsByBounds();
    },
    clearLocations: function () {
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
      this.markers = [];
      this.locations = [];
    },
    setPosition: function (coordinates) {
      if (!this.map) return false;

      if (this.positionMarker) this.positionMarker.setMap(null);
      this.positionMarker = false;
      this.position = {
        lat: Number(coordinates.latitude),
        lng: Number(coordinates.longitude),
      };
      this.positionMarker = new google.maps.Marker({
        position: this.position,
        title: "Your Current Position",
      });
      this.positionMarker.setMap(this.map);

      this.map.setZoom(9);
      this.map.setCenter(this.position);
    },
    selectLocation: function (location) {
      if (!this.map) return false;

      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
      this.markers = [];
      this.locations.forEach((loc) => {
        this.addMarker(loc.location, loc.location.post_title);
      });
    },
    highlightLocation: function (location) {
      // if (this.map)
      //   this.map.setCenter({
      //     lat: Number(location.customFields.latitude[0]),
      //     lng: Number(location.customFields.longitude[0]),
      //   });
      // this.location = location;
    },
    isSelectedLocation: function (location) {
      return location.location.ID == this.location.id;
    },
    directionURL: function (l) {
      return `https://www.google.com/maps/dir/Current+Location/${l.location.customFields.address?.[0]}%20${l.location.customFields.address_2?.[0]}%20${l.location.customFields.city?.[0]},%20${l.location.customFields.state?.[0]}`;
    },
    setScheduleLocation: function (location) {
      let formWrapper = document.querySelector("#gform_wrapper_26");
      if (window.location.href.indexOf("/locations") < 0 && !formWrapper)
        return (window.location.href = "/locations?schedule=" + location.id);
      let form = formWrapper.querySelector("form");

      let w = formWrapper.querySelector(".scheduled-location");
      if (!w) {
        w = document.createElement("div");
        w.classList.add("scheduled-location", "well");
      }

      w.innerHTML = `
          <h3>Selected Service Center</h3>
          <p><strong>${location.post_title}</strong></p>
          <p>${location.customFields.address?.[0]} ${location.customFields.address_2?.[0]},<br />${location.customFields.city?.[0]}, ${location.customFields.state?.[0]} ${location.customFields.zip_code?.[0]}</p>
        `;

      let f = form.querySelector("#input_26_6");
      f.value = location.customFields.st_location_id?.[0];

      let z = form.querySelector("#field_26_7");
      let zi = form.querySelector("#input_26_7");
      zi.value = location.customFields.zip_code?.[0];
      z.style.display = "none";

      formWrapper.insertBefore(w, form);

      new SmoothScroll().animateScroll(formWrapper, false, {
        offset: 200,
      });
    },
  },
  filters: {
    distance(value) {
      return value.toFixed(2) + " mi";
    },
  },
  created: function () {
    if (this.defaultLocation) this.search = this.defaultLocation;
    if (QueryParam("zip")) this.search = QueryParam("zip");
    if (this.search) {
      this.ignoreUserLocation = true;
      // console.log('ignoring user location')
    }
    if (sessionStorage && sessionStorage.position)
      this.position = JSON.parse(sessionStorage.position);
  },
  mounted: function () {
    // console.log('mounted')
    // if(this.$el.getAttribute('data-default-search')) this.ignoreUserLocation = true
    this.initMap();
    setTimeout(() => {
      this.getNearestLocations();
    }, 3);
    // window.mapApiInitialized = this.initMap.bind(this)
    // let script = document.createElement('script');
    // script.src = 'https://maps.googleapis.com/maps/api/js?libraries=geometry&callback=mapApiInitialized';
    // document.body.appendChild(script)

    // let locationFinderToggle = document.querySelector('.target-location-finder')
    // if(locationFinderToggle) locationFinderToggle.addEventListener('click', e => {
    //       e.preventDefault()
    //       new SmoothScroll().animateScroll(this.$el, false, {
    //           offset: 200
    //       })
    //       setTimeout(() => {
    //           let input = this.$el.querySelector('.locations--search-input input')
    //           input.focus({ preventScroll: true })
    //       }, 750)
    // })
  },
};
</script>

<style>
#locations--map-wrapper {
  position: relative;
}

.locations--map-pane {
  flex-grow: 1;
  position: relative;
}

.locations--search-area {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 6;
}

.locations--search-area::before {
  background: #47a2da;
  border: 4px solid #113b67;
  border-radius: 9999px;
  box-shadow: 0 0 0 18px rgba(71, 162, 218, 0.22);
  content: "";
  height: 20px;
  left: 50%;
  position: absolute;
  top: -30px;
  transform: translateX(-50%);
  width: 20px;
}

.locations--search-area .button {
  background: #47a2da;
  border: 3px solid #47a2da;
  box-shadow: none;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.01em;
  min-width: 180px;
  padding: 0.8rem 1rem;
  text-transform: uppercase;
}

@media (max-width: 875px) {
  #locations--map-wrapper #locations--map {
    height: 320px !important;
  }

  .locations--search-area {
    left: 50%;
    top: 50%;
  }
}
</style>
